import { render } from "./HomePageV2.vue?vue&type=template&id=5244b6ad"
import script from "./HomePageV2.vue?vue&type=script&lang=js"
export * from "./HomePageV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__